import logoWhite from 'assets/img/logoWhite.png';
import heroBackground from 'assets/img/gallery/Service4.JPG';

export default function Header() {
    return (
        <div className="relative pt-40 pb-32 flex content-center items-center justify-center h-screen">
            <div
                className="bg-cover bg-center absolute top-0 w-full h-full"
                style={{ backgroundImage: `url(${heroBackground})` }}
            />
            <div className="absolute top-0 w-full h-full bg-black bg-opacity-60" />

            <div className="container max-w-8xl relative mx-auto">
                <div className="flex flex-col items-center justify-center text-center">
                    <div className="flex justify-center">
                        <img
                            src={logoWhite}
                            alt="Rise Up Logo"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
